export default __webpack_public_path__ + "static/media/i4.28484be5.svg";